import React from "react";
import notificationBell from './Icons/notificationBell.png';
import { version } from './Modules/Exports';
import { bigLogo, errorExplinationMark } from './Icons';
import { useNavigate } from 'react-router-dom';
import { useNotification } from "./Notifications/NotificationProvider";
import CachedImage from './Modules/CachedImage';

const NotificationDropdown = ({ notifications, closeUI, renderNotification, akrAuth, akrCookie }) => {
  const { addNotification } = useNotification();
  const navigate = useNavigate();

  const redirectProfiles = (userId) => {
    closeUI("notification");
    navigate(`/profile/${userId}`);
  };

  const acceptFriendRequest = async (userId, notification) => {
    try {
      const response = await fetch(`https://api.kasimakram.com/acceptFriendRequest/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'akrAuth': JSON.stringify(akrAuth),
          'akrCookie': akrCookie
        },
        credentials: 'include'
      });
      const result = await response.json();
      if (response.ok) {
        addNotification({
          title: notification.title || notification.name,
          message: `You are now friends!`,
          imageUrl: notification.imageUrl,
        });
        renderNotification();
      } else {
        closeUI("notification");
        addNotification({
          title: `System Error`,
          message: result.frontFacingError || result.error,
          imageUrl: errorExplinationMark,
        });
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <>
      <div className="ntfc-container">
        <img src={notificationBell} alt="" className="bell-icon" />
        <div className="notification-big-title">{notifications.length === 0 ? "No Notifications" : "Notifications"}</div>
      </div>
      <div className="notification-small-text">{notifications.length === 0 ? "Don' fret, we'll be first to let you know once you get new notifications!" : ""}</div>
      <div className="notification-contnr notification-contnr-morewidth updatedScrollBar">
        {notifications.map((notification, index) => (
          <div key={index} className={`notification-item ${(("buttons" in notification && Object.keys(notification["buttons"]).length > 0) || ("type" in notification && notification["type"] === "frq")) ? "notificationButtons" : ""}`}>
            <CachedImage
              className="notificationImageDropDown"
              userId={Number(notification.userId)}
              src={notification.imageUrl}
              onError={(e) => { e.target.onerror = null; e.target.src = bigLogo }}
              alt=""
            />
            <div className="notification-text">
              <div className="notification-contnr-title">{notification.title.length > 33 ? `${notification.title.slice(0, 30)}...` : notification.title}</div>
              <div className="notification-contnr-message">{notification.message}</div>
            </div>
            {((("buttons" in notification && Object.keys(notification["buttons"]).length > 0) || ("type" in notification && notification["type"] === "frq") || ("type" in notification && notification["type"] === "frp") || ("type" in notification && notification["type"] === "frd")) &&
              <div className="bottom-right-ui-container">
                {"buttons" in notification && Object.entries(notification.buttons).map(([buttonKey, buttonValue], btnIndex) => (
                  <div key={btnIndex} className="bottom-right-ui">{`${buttonKey}`}</div>
                ))}
                {("type" in notification && notification["type"] === "frq" &&
                  <>
                    <div key={90} className="bottom-right-ui greenBG" onClick={() => acceptFriendRequest(notification["userId"], notification)} >{`Accept`}</div>
                    <div key={91} className="bottom-right-ui">{`Ignore`}</div>
                    <div key={92} className="bottom-right-ui" onClick={() => redirectProfiles(notification["userId"])}>{`View`}</div>
                  </>
                )}
                {!(("type" in notification && notification["type"] === "frq" && ("type" in notification && notification["type"] === "frd")) &&
                  <div className="bottom-right-ui">{`Hide`}</div>
                )}
                {((("type" in notification && notification["type"] === "frd") || ("type" in notification && notification["type"] === "frp")) &&
                  <>
                    <div key={82} className="bottom-right-ui" onClick={() => redirectProfiles(notification["userId"])}>{`View`}</div>
                  </>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
      {((window.innerWidth || 0) <= 767 &&
        <div className="bottom-right-ui-container modalBottomUi">
          <div className="bottomRightUiV3" onClick={() => closeUI("notification")}>Close</div>
        </div>
      )}
      <div className="build-number">{version}</div>
    </>
  );
};

export default NotificationDropdown;
